module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAIFJREFUOBFjYBgFuELg////t3DJ4RInSg9Q0X9cBuASx6aHCZdiSsVHDYaHIM6gAEZIA1wVDgY+NSzY9EA11ANpZOm1UE4wkiC6GrgUThfDVVCLAXQl2JlAqoGQmTA1MD141ROlCM0EbHpoFhSjBsNDH1tQ3IbLEs8gRw/xpg9tlQCqnzrQ+0ZCjwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_WidthMax_normal.png
// module id = 323
// module chunks = 0